export default __webpack_public_path__ + "static/media/greenarrow-icon.7a5efb86.svg";